import { NextUIProvider } from '@nextui-org/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { ServerTerminal } from '@portal/components/ServerTerminal';
import { TerminalConnectionPoolProvider } from '@portal/context/TerminalConnectionPool';
import { TsrestProvider } from '@portal/provider/tsrest';
import { router } from '@portal/router';

import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <TsrestProvider>
    <NextUIProvider>
      <TerminalConnectionPoolProvider>
        <RouterProvider router={router} />
        <ServerTerminal />
        <ToastContainer position='bottom-right' />
      </TerminalConnectionPoolProvider>
    </NextUIProvider>
  </TsrestProvider>
);
